import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
var teasers = document.querySelectorAll('.highlights__teaser');

//init / first teaser
function getPosition(elem) {
  var highlights_wrapper = document.querySelector('.highlights');
  var top_value = getOffset(elem).top - getOffset(highlights_wrapper).top
  var positions = [top_value, getOffset(elem).left];
  return positions;
}

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}    

docReady(function() {
  // DOM is loaded and ready for manipulation here
  teasers.forEach(function(elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: "top center",
      end: "bottom center",
      onEnter: function() { spotPosition(elem) }, 
      onEnterBack: function() { spotPosition(elem) }
    });
  })
});

function spotPosition(elem) {
  var offset = elem.dataset.offset;
  // console.log(id);

  var spot = document.querySelector('.highlights__spotlight__clip');
  var positions = getPosition(elem);
  var left_pos = positions[1] + 20 -  (elem.offsetHeight / 4);


  console.log(parseInt(left_pos) + parseInt(offset) + "px")

  spot.style.top = positions[0] - 20 + "px";
  spot.style.left = parseInt(left_pos) + parseInt(offset) + "px";
  spot.style.width =  elem.offsetHeight + 40 + "px";
  spot.style.height =  elem.offsetHeight + 40 + "px";
}

  


